<template>
    <section>
        <div class= "header">
            <h1 class="title">
                Attachment                
            </h1>
        </div>

        <div class= "body" v-if="attachment_type.includes('video')">
            <video video controls>
                <source :src="url" type="video/mp4">
                <source :src="url" type="video/ogg">
            </video>
        </div>
        <div class= "body" v-if="attachment_type.includes('image')">
             <img :src="url" >
        </div>
        <div class= "footer">
            <button class="btn" @click="close">Close</button>
        </div>
    </section>   
</template>

<script>
export default {
  props: ['url', 'attachment_type'],
  methods: {
      close(){
          this.$emit('close')
      },
  },
}
</script>

<style scoped>
    .header {
        min-height: 16.428571429px;
        padding: 20px;
        border-bottom: 1px solid #e5e5e5;
    }
    
    .body{
        position: relative;
        padding: 20px;
    }
    img{
        display: block;
        margin: auto;
        min-height: 300px;
        max-height: 900px;
    }
    video{
        display: block;
        margin: auto;
        min-height: 300px;
        max-height: 900px;
    }
    .footer{
        padding: 15px;
        border-top: 1px solid #e5e5e5;
        background-color: white;
    }

    button{
        width: 100px;
    }
    
    @media only screen and (max-width: 543px) and (min-width: 375) , (min-device-width: 320px) and (max-device-width: 1024px){
        img{
            display: block;
            width: 30vh;
            height: 30vh;
            margin-left: auto;
            margin-right: auto;
        }
        video{
            display: block;
            width: 30vh;
            height: 30vh;
            margin-left: auto;
            margin-right: auto;
        }
    }


</style>


// WEBPACK FOOTER //
// src/components/job/stop-action/AttachmentForJobModal.vue